<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png"
        alt="" />
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Reporte Mora Presunta</h1>
                <button
                    mat-flat-button
                    class="custom-button-primary no-print"
                    (click)="generatePDF()"
                    [disabled]="isPDFLoading">
                    <mat-icon aria-hidden="false" aria-label="Icono de descarga" fontIcon="get_app" class="icon-download"></mat-icon>
                    Descargar Resultado
                    <mat-icon *ngIf="isPDFLoading" iconPositionEnd>
                        <mat-spinner class="custom-white-spinner" diameter="15"></mat-spinner>
                    </mat-icon>
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                    <mat-chip class="chip-rut"><strong>RUT:</strong> {{content.DatosBasicosSolicitud.Rut | number:
                        '1.0-0'}}-{{content.DatosBasicosSolicitud.DV | uppercase}}</mat-chip>
                </mat-chip-set>
            </div>

            <div class="col-12">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Datos de la empresa</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>

                        <div class="two-equal-columns-grid p-5">
                            <div class="border grid p-5">
                                <div class="font-weight-500">Rut empleador:</div>
                                <div>{{ content.Reporte.report.rutEmpleador ? (content.Reporte.report.rutEmpleador | rutFormat) : '' }}</div>

                                <div class="font-weight-500">Razón social:</div>
                                <div>{{ content.Reporte.report.razonSocial }}</div>
                            </div>
                            <div class="border grid p-5">
                                <div class="font-weight-500">Totales</div>
                                <div></div>

                                <ng-container *ngFor="let total of totals">
                                    <div class="font-weight-500">{{ total.tipoProducto}}:</div>
                                    <div>{{total.count | number: '1.0-0'}}</div>
                                </ng-container>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-12 mt-5 mb-3">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Detalles</strong>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-content>

                        <div class="row p-5">
                            <div class="col-12 border mx-auto px-0">

                                <div class="table-responsive">
                                    <table mat-table [dataSource]="afiliadosDataSource" class="custom-print-table">
                                        <ng-container matColumnDef="rutAfiliado">
                                            <th mat-header-cell *matHeaderCellDef>Rut Afiliado</th>
                                            <td mat-cell *matCellDef="let element">{{ element.rutAfiliado | rutFormat }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="nombreAfiliado">
                                            <th mat-header-cell *matHeaderCellDef>Nombre Afiliado</th>
                                            <td mat-cell *matCellDef="let element">{{ element.nombreAfiliado }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="tipoProducto">
                                            <th mat-header-cell *matHeaderCellDef>Tipo Producto</th>
                                            <td mat-cell *matCellDef="let element">{{ element.tipoProducto }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="afpOAfc">
                                            <th mat-header-cell *matHeaderCellDef>AFP o AFC</th>
                                            <td mat-cell *matCellDef="let element">{{ element.afpOAfc }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="fechaCarta">
                                            <th mat-header-cell *matHeaderCellDef>Fecha carta</th>
                                            <td mat-cell *matCellDef="let element">{{ element.fechaCarta | date: 'dd/MM/yyyy' }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="contacto">
                                            <th mat-header-cell *matHeaderCellDef>Contacto</th>
                                            <td mat-cell *matCellDef="let element">{{ element.contacto }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="telefonoContacto">
                                            <th mat-header-cell *matHeaderCellDef>Teléfono contacto</th>
                                            <td mat-cell *matCellDef="let element">{{ element.telefonoContacto }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="correoContacto">
                                            <th mat-header-cell *matHeaderCellDef>Correo contacto</th>
                                            <td mat-cell *matCellDef="let element">{{ element.correoContacto }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="periodoRegularizar">
                                            <th mat-header-cell *matHeaderCellDef>Período a regularizar</th>
                                            <td mat-cell *matCellDef="let element">{{ element.periodoRegularizar }}</td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="afiliadosDisplayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: afiliadosDisplayedColumns;"></tr>

                                        <tr class="mat-mdc-row" *matNoDataRow>
                                            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="afiliadosDisplayedColumns.length">
                                                No hay datos disponibles
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>